import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=1167ec78&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/exhibition.css?vue&type=style&index=0&id=1167ec78&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167ec78",
  null
  
)

export default component.exports